export const awsConfig = {
    UserPoolId: `${process.env.REACT_APP_USERPOOLID}`,
    ClientId: `${process.env.REACT_APP_CLIENTID}`,
};